import { RequestError, RequestErrorArgs } from "./RequestError"

export class TooManyRequestsError extends RequestError {
  constructor(args: RequestErrorArgs) {
    super(args)
    this.name = "TooManyRequestsError"
  }
}
